import * as React from 'react';
import { PureComponent } from 'preact-compat';
import { config } from './config'
/**
* the iframe is used to set cookie against wootag domain,
* which then gets sent to its parent (player) and passed in events
*/
class Pixel extends PureComponent {
	render() {
		let domain = config.DOMAIN;
		if (!domain.includes('wootag')) {
			domain = 'https://www.wootag.com';
		}
		return (
			<iframe
				src={`${domain}/pixel.html`}
				style={{ display: 'none' }}
			/>
		);
	}
}

export default Pixel;



// WEBPACK FOOTER //
// ./components/pixel.js